export default {"src":"/_next/static/media/cx.f21b79dd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};